import React from "react";
import {SidebarData} from "../resources/navbar-data/sidebarData"
import Sidebar from "../common/Sidebar";

const Admin = ({children}) => {
  // eslint-disable-next-line react/no-children-prop
  return <Sidebar SidebarData={SidebarData} children={children}/>
}

export default Admin